import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { BULK_UPDATE_LOCATIONS_MUTATION } from '../graphql/mutations'
import { BULK_UPDATE_LOCATIONS } from '../redux/action-types'

const useBulkUpdateLocationsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.locations.locations)

  const mutate = useCallback(
    (ids, data, onSuccess) =>
      apolloService.mutate({
        mutation: BULK_UPDATE_LOCATIONS_MUTATION,
        variables: { ids, data },
        dispatch,
        action: BULK_UPDATE_LOCATIONS,
        onSuccess,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useBulkUpdateLocationsMutation
